export default "__VITE_ASSET__CmnpGBdz__"